// extracted by mini-css-extract-plugin
export default {"mainCard":"AddCarousal_mainCard__9rHad","imgCard":"AddCarousal_imgCard__Ml1Qg"};